import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { Button, Dialog, Paper, TextField } from "@mui/material";

export default function useSave(state) {
  const [open, setOpen] = useState();
  const [error, setError] = useState([]);

  function DialogSave() {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {error[0] ? error[0]?.message : null}
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  async function fetchGraphql(body) {
    const createHeaders = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("authorization", localStorage.getItem("token"));
      myHeaders.append(
        "Access-Control-Allow-Origin",
        "*"
      );
      return myHeaders;
    };

    return await fetch(
      process.env.REACT_APP_API_URL || "http://localhost:3011/graphql",
      {
        method: "POST",
        headers: createHeaders(),
        body: JSON.stringify(body),
        redirect: "follow",
      }
    )
      .then((result) => result.json())
      .then((result) => {
        console.log(result);
        if (result.errors) {
          setError(result.errors);
          setOpen(true);

          return result;
        } else {
          return result;
        }
      })
      .catch((error) => {
        console.log(error);

        return {
          errors: error,
        };
      });
  }

  return {
    fetchGraphql,
    DialogSave,
  };
}
